export const FETCH_USER_FEEDS = 'FETCH_USER_FEEDS';
export const FETCH_USER_FEEDS_SUCCESS = 'FETCH_USER_FEEDS_SUCCESS';
export const FETCH_USER_FEEDS_ERROR = 'FETCH_USER_FEEDS_ERROR';
